import React, { useState } from 'react'
import HeaderBack from '../../components/global/HeaderBack'
import { useTranslation } from 'react-i18next'
// import logo from './../../assets/clients/client.png'
import { Box, Grid2, TextField } from '@mui/material'
import { ReactComponent as SearchIcon } from './../../assets/icons/SearchIcon.svg';
// import CategoriesSlider from '../../components/visitor/JoinNetwork/CategoriesSlider'
import { useTheme } from '@emotion/react'
// import FormInput from '../../components/ContactForm/FormInput'
import WrapperSection from '../../components/global/WrapperSection'
import i18next from 'i18next'
import GridItems from '../../components/global/GridItems'
import Card from '../../components/ClientsSection/Card'
import { useGetStoreNetwork } from '../../hooks/StoreNetwork/useGetStoreNetwork'
// import { useCategory } from '../../hooks/useCategory'
// import { useCities } from '../../hooks/useCities'
import { useEffect } from 'react'
// import LoadingPage from '../../components/global/LoadingPage'
import DarkModeToggle from '../../components/global/DarkModeToggle';
import TransLang from '../../components/Navbar/TransLang';
import { Helmet } from 'react-helmet-async';
import { LoadingSkeletons } from '../../components/global/loadings/LoadingSkeletons';
import { useDarkMode } from '../../context/DarkModeContext';
// import {  useParams } from 'react-router-dom'; //useNavigate,
// import HomeIcon from '@mui/icons-material/Home';



const JoinNetwork = () => {
  // const { slug } = useParams()
  let lng = i18next.language
  const { isDarkMode } = useDarkMode();
  const { t } = useTranslation()
  const theme = useTheme()
  // const country_id = localStorage.getItem('country-id')
  // const { category, isLoading: isLoadingCategory } = useCategory()
  // const { cities, isLoading: isLoadingCities } = useCities(country_id && country_id)
  // const [activeCategory, setActiveCategory] = useState(null)
  // const [activeCity, setActiveCity] = useState(null)
  const [searchOpen, setSearchOpen] = useState(false)
  const [searchText, setSearchText] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState('')
  const { storeNetwork, isLoading } = useGetStoreNetwork(
    debouncedSearch,
    ) 
    /**
     * activeCity === 'null' ? '' : activeCity,
    activeCategory || ''
     * */ 
  useEffect(() => {
    const handler = setTimeout(() => setDebouncedSearch(searchText), 500)
    return () => clearTimeout(handler)
  }, [searchText])

  const handleSearch = (e) => setSearchText(e.target.value)
  const toggleSearch = () => {
    setSearchOpen(!searchOpen)
    if (searchOpen) setSearchText('')
  }
  // const navigate = useNavigate();
  // const initialSlug = localStorage.getItem('initialStoreSlug');
  // const initialLogo = localStorage.getItem('initialStoreLogo');
  // const store_network = localStorage.getItem('store_network');
  // const goToInitialStore = () => {
  //   if (initialSlug) {
  //     navigate(`/${initialSlug}`, { replace: true });
  //   }
  // };
  // if (isLoading) return <LoadingPage />

  return (
    <>
      <Helmet>
        <title>{t('brandNetwork.title')}</title>
        <meta name="description" content={t('heroSection.line5')} />
        <meta name="keywords" content={t('seo.keywords')} />
        <meta name="author" content={t('seo.author')} />
        <meta name="robots" content="index, follow" />
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content={t('seo.language')} />
        {/* Open Graph Tags - لفيسبوك والسوشال ميديا */}
        <meta property="og:title" content={t('brandNetwork.title')} />
        <meta property="og:description" content={t('heroSection.line5')} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content="/web-app-manifest-512x512.png" />
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="/web-app-manifest-512x512.png" />
        <meta name="twitter:title" content={t('brandNetwork.title')} />
        <meta name="twitter:description" content={t('heroSection.line5')} />
        <meta name="twitter:image" content="/web-app-manifest-512x512.png" />
        {/* Favicon & Touch Icons */}
        <link rel="icon" type="image/png" href="/favicon-96x96.png" sizes="96x96" />
        <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
        <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
        {/* Canonical Link */}
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <HeaderBack title={t('visitor.networking')} top={0} path={-1}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <SearchIcon
              fontSize='large'
              color='secondary.text'
              onClick={toggleSearch}
              style={{ cursor: 'pointer' }}
            />
            {searchOpen && (
              <TextField
                autoFocus
                variant="standard"
                placeholder={lng === 'en' ? 'Search...' : 'بحث...'}
                value={searchText}
                onChange={handleSearch}
                sx={{
                  ml: 1,
                  '& .MuiInputBase-input': {
                    fontSize: '14px',
                    color: theme.palette.secondary.text,
                  },
                }}
              />
            )}
          </Box>
          <DarkModeToggle fill={isDarkMode ? '#fff' : '#3C1FAB'} />
          <TransLang color={isDarkMode ? '#fff' : '#3C1FAB'} />
        </Box>
        <br />
        {/* {initialSlug && slug !== `${initialSlug}` && store_network === 'true' && (
          <IconButton onClick={goToInitialStore} sx={{
            mr: 1,
            position: slug && 'absolute',
            right: lng === 'ar' ? 'auto' : 0,
            left: lng === 'ar' ? 0 : 'auto'
          }}>
            {initialLogo
              ? <CardMedia
                component="img"
                src={initialLogo}
                alt={initialLogo}
                sx={{ width: 32, height: 32, borderRadius: '50%' }}
              />
              : <HomeIcon />
            }
          </IconButton>
        )} */}
      </HeaderBack>
      {/* <Box sx={{ background: { md: 'transparent', xs: theme.palette.nav.main }, mt: { md: 2, xs: 0 }, px: 2 }}>
        <CategoriesSlider
          categories={[
            { id: null, name: lng === 'en' ? 'All' : 'الكل' },
            ...(category?.data || [])
          ]}
          activeCategory={activeCategory}
          onCategoryClick={(id) => setActiveCategory(id)}
        />
      </Box> */}
      <WrapperSection>
        {/* <Box sx={{ width: { md: "90%", xs: "90%" }, textAlign: lng === 'en' ? 'end' : "start" }}>
          <FormInput
            type="select"
            selectedValue={activeCity}
            handleSelectChange={(e) => setActiveCity(e.target.value)}
            options={[
              { id: null, name: lng === 'en' ? 'All cities' : 'كل المحافظات' },
              ...(cities?.data || [])
            ]}
          />
        </Box> */}
        {isLoading ? <LoadingSkeletons /> // || isLoadingCities || isLoadingCategory
          :
          <GridItems data={storeNetwork?.data}
            render={(client) =>
              <Grid2 size={{ xs: 6, md: 2 }} key={client?.id} >
                <Card client={client} />
              </Grid2>
            } />
        }
      </WrapperSection>
    </>
  )
}

export default JoinNetwork